import modalComponent from 'jimi-uxkit/packages/components/modal/modal.vue';
import i18n from '@/i18n/index.js';
export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function (Vue) {
    if (Vue) {
      let SHOWMODAL = Vue.extend(modalComponent);
      const createEl = () => {
        return new SHOWMODAL({
          i18n,
          el: document.createElement('div')
        });
      };

      let modal = {
        list: [], // 弹窗数组
        /**
         * 显示弹窗
         * @param {Object} config 配置对象
         */
        show(config) {
          let instance = createEl();
          instance.showModal = true;
          Object.assign(instance, config || {});
          if (config.isTopModal) {
            let el = window.top.document.body;
            el.appendChild(instance.$el);
          } else {
            document.body.appendChild(instance.$el);
          }
          this.list.push(instance);
          return instance;
        },

        /**
         * 关闭弹窗
         * @param {Boolean} flag true为iframe调用删除顶级body下的弹窗
         */
        hide(flag) {
          if (this.list[this.list.length - 1]) {
            this.list[this.list.length - 1]['showModal'] = false;
            this.list.pop();
            setTimeout(() => {
              this.hideAll(flag);
            }, 1000);
          }
        },

        /**
         * 关闭所有弹窗
         * @param {Boolean} flag true为iframe调用删除顶级body下的弹窗
         */
        hideAll(flag) {
          let el = document.querySelectorAll('body > .ux-show-modal');
          for (let i = 0; i < el.length; i++) {
            if (!el[i].__vue__.showModal) {
              el[i].parentNode.removeChild(el[i]);
            }
          }

          if (flag) {
            let doc = window.top.document;
            let el = doc.querySelectorAll('body > .ux-show-modal');
            for (let i = 0; i < el.length; i++) {
              if (!el[i].__vue__.showModal) {
                el[i].parentNode.removeChild(el[i]);
              }
            }
          }
        }
      };
      Vue.prototype.$uxModal = modal;
      Vue.prototype.$modal = modal; // 保留兼容之前的写法, 之后只留uxModal
      Vue.component(modalComponent.name, modalComponent);
    }
  }
};
